<template>
  <div class="add-waiting-team-card">
    <header>
      <div class="team-name-block">
        <h4>
          {{ team.name }}
        </h4>
        <button @click="isShowPlayers = !isShowPlayers"
                v-if="team.stageTeamMembers && team.stageTeamMembers.length"
                class="show-players-button"
                :disabled="isLoadingSubmit">
          {{ isShowPlayers ? 'Скрыть игроков' : 'Показать игроков' }}
        </button>
      </div>
      <span class="id-team">id: {{ team.id }}</span>
    </header>
    <div class="team-add-action-wrapper">
      <div v-if="team?.captain" class="captain-team">
        <span class="label">Капитан:</span> <span class="value">{{ team?.captain?.full_name }} ({{ team?.captain?.username }})</span>
      </div>
      <div v-else></div>
      <div class="d-flex justify-content-end action-block align-items-end">
        <b-button class="custom-remove-team"
                  @click="isShowDeleteTeamFromStageModal = true"
                  variant="primary">Удалить из этапа</b-button>
<!--        <b-dropdown id="dropdown-right"-->
<!--                    right-->
<!--                    text="Удалить"-->
<!--                    variant="primary"-->
<!--                    :class="[!isHideAdd && 'mr-2 mt-2']"-->
<!--                    class="custom-remove-team-dropdown">-->
<!--          <b-dropdown-item @click="isShowDeleteTeamFromStageModal = true">Из этапа</b-dropdown-item>-->
<!--          <b-dropdown-item @click="isShowDeleteTeamFromTournamentModal = true" href="#">Из турнира</b-dropdown-item>-->
<!--        </b-dropdown>-->
        <template v-if="!isHideAdd">
          <template v-if="!hasAdded">
            <button @click="addTeam"
                    class="select-team-button"
                    :disabled="isLoadingSubmit">
              {{ isLoadingSubmit ? 'Добавляем' : 'Добавить' }}
            </button>
          </template>
          <span v-if="hasAdded" class="team-has-added">Добавлена</span>
        </template>
      </div>
    </div>
    <TeamPlayersTable v-if="isShowPlayers" :players="players" title="Игроки этапа"/>
    <b-alert v-if="errorText" show variant="danger" style="margin: 10px 0 0 0">{{ errorText }}</b-alert>
    <Modals name="DeleteTeamFromStageTournament" v-model="isShowDeleteTeamFromStageModal" title="Удаление команды из этапа" :params="{ team, stage: selectedStage }" @submit="(team) => $emit('clearTeamFromStorage', { team, listName })"/>
    <Modals name="DeleteTeamFromTournament" v-model="isShowDeleteTeamFromTournamentModal" title="Удаление команды из турнира" :params="{ team, tournament }" @submit="(team) => $emit('clearTeamFromStorage', { team, listName })"/>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import api from "@/api/api";
import Modals from "@/components/modals/index.vue";
import TeamPlayersTable from "@/components/Tournament/components/TeamPlayersTable.vue";

export default {
  name: "AddWaitingTeamCard",
  components: {
    Modals,
    TeamPlayersTable,
  },
  props: {
    team: {
      type: Object,
      required: true
    },
    isHideAdd: {
      type: Boolean,
      default: false
    },
    listName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      errorText: null,
      isLoadingSubmit: false,
      isShowPlayers: false,
      isShowDeleteTeamFromStageModal: false,
      isShowDeleteTeamFromTournamentModal: false
    }
  },
  computed: {
    ...mapState('moduleNewTournament', ['selectedStageId', 'selectedRoundId', 'selectedGroupId', 'tournament', 'groupsWithTeamsByMLBB', 'teamsByGroup', 'tournament']),
    ...mapGetters('moduleNewTournament', ['selectedGroup', 'selectedStage']),
    hasAdded() {
      // For MLBB
      if (this.tournament.game.slug === 'mlbb') {
        const allGroupTeams = this.groupsWithTeamsByMLBB.reduce((state, group) => {
          state = [...state, ...group.group_teams]
          return state
        }, [])
        if (!allGroupTeams || !allGroupTeams.length) return false
        return allGroupTeams.some((group) => (group?.team?.id || 0) === this.team.id)
      }
      // For PUBG
      if (!this.teamsByGroup || !this.teamsByGroup.length) return false
      return this.teamsByGroup.some(({ team: { id } }) => id === this.team.id)
    },
    players() {
      const gameIdField = this.tournament.game.slug === 'mlbb' ? 'mlbb_id' : 'pubg_id'
      return (this.team.stageTeamMembers || []).map((player) => ({
        userId: player.user?.id || player.user_id,
        username: player.user?.username,
        nick: this.getGameProfile(player)?.fields?.nick,
        gameId: this.getGameProfile(player)?.fields?.[gameIdField],
      }))
    },
  },
  methods: {
    getGameProfile(player) {
      return (player.user?.game_profiles || []).find(({ game_id }) => game_id === this.tournament.game_id)
    },
    async addTeam() {
      try {
        this.errorText = null
        this.isLoadingSubmit = true
        await api.tournament.newTransferTeamsToNextStage({
          group_id: this.selectedGroupId,
          stage_id: this.selectedStageId,
          stage_team_ids: [this.team.stage_team_id]
        })
        if (this.tournament.game.slug === 'pubg-mobile')
          await this.$store.dispatch('moduleNewTournament/getTeamsByGroup', { id: this.selectedGroupId })
        if (this.tournament.game.slug === 'mlbb')
          await this.$store.dispatch('moduleNewTournament/getGroupsWithTeamsByMLBB', { roundId: this.selectedRoundId })
        await this.$store.dispatch('moduleNewTournament/getTournament', {
          id: this.$route.params.standingId
        })
      } catch (e) {
        this.errorText = e.response.data.message
      } finally {
        this.isLoadingSubmit = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.custom-remove-team-dropdown::v-deep {
  button {
    color: #ff0000c9 !important;
    border-color: #ff0000c9 !important;
    background-color: white !important;

    font-size: 11px;
    border-radius: 13px;
    padding: 5px 13px 5px 13px;
    transition: 0.2s;
    line-height: 13px;

    &:hover, &:focus {
      color: white !important;
      background-color: #ff0000c9 !important;
    }
  }
}

.custom-remove-team {
  color: #ff0000c9 !important;
  border-color: #ff0000c9 !important;
  background-color: white !important;

  font-size: 11px;
  border-radius: 13px;
  padding: 5px 13px 5px 13px;
  transition: 0.2s;
  line-height: 13px;
  white-space: nowrap;

  &:hover, &:focus {
    color: white !important;
    background-color: #ff0000c9 !important;
    border-color: #ff0000c9 !important;
  }
}

.add-waiting-team-card {
  background: white;
  padding: 20px;
  border-radius: 10px;
  transition: .2s;

  margin-bottom: 20px;

  header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .id-team {
      color: #808080c7;
      font-size: 12px;

    }
  }

  .team-name-block {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .show-players-button {
    display: block;
    font-size: 13px;
    border-radius: 15px;
    padding: 5px 13px 5px 13px;
    background: white;
    color: #7366ff;
    border: none;
    transition: .2s;
    outline: 1px solid #7366ff;
    outline-offset: -1px;

    &:hover {
      background: #7366ff;
      color: white;
    }
  }

  h4 {
    margin: 0;
    font-size: 16px;

    @media screen and (max-width: 400px) {
      font-size: 14px;
    }

  }

  .team-has-added {
    color: #008300de;
    text-align: right;
  }

  .team-add-action-wrapper {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    @media screen and (max-width: 550px) {
      display: block;
    }

    .action-block {
      @media screen and (max-width: 550px) {
        margin-top: 10px;
      }
    }
  }

  .select-team-button {
    display: block;
    font-size: 13px;
    border-radius: 15px;
    padding: 5px 13px 5px 13px;
    background: #dad6ff;
    color: #7366ff;
    border: none;
    transition: .2s;

    &:hover {
      background: #7366ff;
      color: white;
    }

    &.reject {
      background: white;
      outline: 1px solid #dad6ff;
      outline-offset: -1px;
      color: #dad6ff;

      &:hover {
        outline: 1px solid #7366ff;
        color: #7366ff;
      }
    }
  }

  .captain-team {
    margin-top: 10px;
    display: flex;
    align-items: center;

    @media screen and (max-width: 500px) {
      display: block;
    }

    .label {
      color: black;
      font-size: 16px;
      margin-right: 6px;
    }

    .value {
      color: #000000ab;
      margin-bottom: -2px;
    }
  }
}
</style>